<template>
  <div id="signout">
    <div>
      <br /><br /><br />
      <h2>{{ $route.params.message }}</h2>
      <br /><br /><br />
    </div>
  </div>
</template>

<script>
import { getCheckInDataMixin } from "@/mixins.js";

export default {
  name: "SignoutSuccess",
  mixins: [getCheckInDataMixin],
  components: {},
  data() {
    return {};
  },
  computed: {},
  methods: {},
  mounted() {
    const signInCode = localStorage.getItem("signInCode");
    const signInData = JSON.parse(localStorage.getItem("userFormSentData"));

    if (this.isKiosk) {
      localStorage.removeItem("userVisitorData");
      setTimeout(() => {
        this.$router.push(`/${signInCode || (signInData || {}).code || ""}`);
      }, 2000);
    }
  }
};
</script>

<style lang="scss"></style>
